<template>
  <div>
    <epi-offcanvas :opening-event-name="openingEventName" title="신규 고객">
      <template v-slot:body>
        <customer-add-form />
        <div class="hstack gap-3 justify-content-center">
          <button class="btn btn-primary">추가하기</button>
        </div>
      </template>
    </epi-offcanvas>
  </div>
</template>

<script>
import { EventName } from "@/const";

export default {
  name: "CustomerAddOffcanvas",
  data() {
    return {
      openingEventName: EventName.CustomerAddOffcanvasOpening,
    };
  },
};
</script>
